import validate from "/workspace/node_modules/.pnpm/nuxt@3.20.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_6fe0d62be4ded556d894a05336dd022f/node_modules/nuxt/dist/pages/runtime/validate.js";
import reset_45alerts_45global from "/workspace/frontend/middleware/resetAlerts.global.js";
import manifest_45route_45rule from "/workspace/node_modules/.pnpm/nuxt@3.20.2_@emnapi+core@1.9.2_@emnapi+runtime@1.9.2_@parcel+watcher@2.5.6_@types+node@_6fe0d62be4ded556d894a05336dd022f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  reset_45alerts_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/workspace/frontend/middleware/authenticated.js"),
  "daily-planning-admin": () => import("/workspace/frontend/middleware/daily-planning-admin.ts"),
  "daily-planning-rotating": () => import("/workspace/frontend/middleware/daily-planning-rotating.ts"),
  "network-competences-admin": () => import("/workspace/frontend/middleware/network-competences-admin.ts"),
  "rotation-planning-admin": () => import("/workspace/frontend/middleware/rotation-planning-admin.ts")
}